<template>
  <Form
    ref="form"
    autocomplete="off"
    hide-required-mark
    :rules="loginRules"
    class="password-login"
    :model="body"
  >
    <FormItem
      v-show="mode === 'email'"
      :label="$t('login.email-label')"
      prop="email"
    >
      <Input
        v-model="body.email"
        name="email"
        type="text"
        :disabled="isShowVerify"
        :placeholder="$t('login.email-placeholder')"
      />
    </FormItem>
    <FormItem
      v-show="mode === 'phone'"
      :label="$t('login.phone-label')"
      prop="tel"
    >
      <PhoneInput
        v-model="body.tel"
        name="tel"
        :disabled="isShowVerify"
        :placeholder="$t('login.phone-placeholder')"
      />
    </FormItem>
    <FormItem
      v-if="!isShowVerify"
      :label="$t('login.password-label')"
      prop="password"
    >
      <Input
        v-model="body.password"
        type="password"
        name="password"
        autocomplete="new-password"
        :password="true"
        :placeholder="$t('login.password')"
      />
    </FormItem>
    <FormItem
      v-if="isShowVerify"
      :label="$t(`login.${mode}-verification-label`)"
      prop="code"
    >
      <VerificationCode
        v-model="body.code"
        :type="mode"
        :username="apiParams.username"
        :tel-code="apiParams.tel_code"
        :placeholder="$t(`login.${mode}-verification-placeholder`)"
        @success="$panel.showNotice(verifySuccessMessage)"
        @geetest-pass="geetestPass"
        @error="handleErrors"
      />
    </FormItem>
    <div class="empty-content">
      <ErrorTips v-if="error" :value="error.error_description" />
    </div>
    <button
      :disabled="!isBtnEnabled"
      class="button button-primary"
      type="submit"
      @click="login"
    >
      <Loading v-if="loading" size="sm" theme="theme-dark" />
      {{ $t('login.buttonText') }}
    </button>
  </Form>
</template>
<script>
import Icon from 'com/Icon'
import Loading from 'com/Loading'
import Form from 'com/Form'
import PhoneInput from '../PhoneInput'
import VerificationCode from '../VerificationCode'
import ErrorTips from '../ErrorTips'
import verifyMixin from '../verifyMixin'
import Input from 'com/Input'
import storage from 'utils/storage'

const FormItem = Form.Item

export default {
  name: 'PasswordLogin',
  components: {
    ErrorTips,
    Input,
    Form,
    FormItem,
    VerificationCode,
    PhoneInput,
    Loading,
    Icon
  },
  mixins: [verifyMixin],
  props: ['mode', 'isShowVerify', 'error', 'loading'],
  inject: ['$panel'],
  data() {
    const { email, tel } = this.getStoreLoginAccount()
    return {
      body: {
        email: email,
        tel: tel,
        password: '',
        geetestData: '',
        code: '' // 手机/邮箱验证码
      }
    }
  },
  computed: {
    apiParams() {
      const params = {
        grant_type: this.mode
      }
      if (this.mode === 'phone') {
        params.username = this.body.tel.phone
        params.tel_code = this.body.tel.code
      } else {
        params.username = this.body.email
      }
      params.login_password = this.body.password
      // 展示手机验证码码后使用快速登录，需要传验证码
      if (this.isShowVerify) {
        params.verify_code = this.body.code
      }

      return params
    },
    isBtnEnabled() {
      if (this.mode === 'phone') {
        return this.body.tel && this.body.tel.phone && this.body.password
      } else {
        return this.body.email && this.body.password
      }
    },
    verifySuccessMessage() {
      return this.mode === 'email'
        ? this.$t('login.email-verify-success-message')
        : this.$t('login.phone-verify-success-message')
    }
  },
  watch: {
    mode() {
      this.reset()
    },
    isShowVerify() {
      this.body.code = ''
      this.geetestData = ''
    },
    body: {
      handler() {
        this.$panel.error = null
      },
      deep: true
    }
  },
  created() {
    this.reset()
  },
  methods: {
    geetestPass(data) {
      this.geetestData = data
    },
    login(e) {
      this.$track('login_login_button')
      e.preventDefault()
      this.$refs.form.validate(valid => {
        if (valid) {
          const params = { ...this.apiParams, ...this.geetestData }
          this.$emit('login', params, this.isShowVerify)
        }
      })
    },
    handleErrors(error) {
      this.$emit('error', error)
    },
    clearErrors() {
      this.$refs.form && this.$refs.form.clearErrors()
    },
    reset() {
      this.body.password = ''
      this.body.code = ''
      this.geetestData = {}
    },
    getStoreLoginAccount() {
      const { grant_type, username, tel_code } =
        storage.get('login-params') || {}
      if (grant_type === 'email') {
        return {
          email: username,
          tel: ''
        }
      }
      if (grant_type === 'phone') {
        return {
          email: '',
          tel: {
            phone: username,
            code: tel_code
          }
        }
      }
      return {
        email: '',
        tel: ''
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import '~uikit';
.password-login {
  .empty-content {
    min-height: 45px;
  }
  .button {
    width: 100%;
    height: 40px;
    line-height: 40px;
    padding: 0;
    .tt-loading {
      border-left-color: @pure-white;
    }
  }
}
</style>
